module.exports = __webpack_public_path__ + "img/20.c5d37428.png";